// extracted by mini-css-extract-plugin
export default {"floatLeft":"Header_floatLeft__t2+rL","menu":"Header_menu__bKlxq"};